import React, { Component } from "react";
import _ from 'i18n';
import { connect } from "react-redux";
import EventLineChart from "./EventLineChart";
import EventLineChartLegend from "./EventLineChartLegend";
import EventLineChartDetails from "./EventLineChartDetails";
import EventLineChartFilters from "./EventLineChartFilters";
import {
  fetchRegistrantLineChartCAData,
  fetchRegistrantLineChartData,
  getSeasonsValues
} from "../../../../actions/thunks/eventStats";
import EventLineChartErrorHandler from "./EventLineChartErrorHandler";
import moment from "moment";
import { showErrorNotification } from "../../../../services/utils";
import CompareStats from "./CompareStats/CompareStats";
import axios from "axios";
import BudgetManagementModal from "../BudgetManagement/BudgetManagementModal";
import EventLineChartLegendFormat from "./EventLineChartLegendFormat";
import { getAccumulateEventStats, getActivePremium, getCommandInfo, startCommandCumulateByFormat, startCommandGetCANbrInscriptionByFormat } from "../../../../actions/thunks/statistics";
import { getParticipantsStatsAction } from "../../../../actions/thunks/eventStats";
import EventLineChartFormat from "./EventLineChartFormat";
import { CommonLoader } from "../../../common/CommonLoader";
import CompareStatsChart from "./CompareStats/CompareStatsChart";
import { SyncOutlined } from "@ant-design/icons";

@connect(store => ({
  auth: store.auth
}))
class EventRegistrantLineChart extends Component {

  constructor(props) {
    super(props);

    this.state = {
      chartLinesToShow: this.props.auth.currentClient.businessType === 'SUPER_CHAIN' ? ['formations', 'cycles', 'cycles_essential', 'saisons', 'monthly_premium', 'yearly_premium', 'congrès'] : (this.props.auth.currentClient.businessType === 'MASTER_CHAIN') ? ['formations', 'cycles'] : ['formations'],
      chartLinesToShowFormat: [],
      formatData: [],
      formatCAData: [],
      isFormatFetching: false,
      isFormatError: false,
      fetching: true,
      data: [],
      isError: false,
      CAfetching: true,
      CAdata: [],
      dataPrevYear: [],
      dataPrevYearFetching: true,
      CAdataPrevYear: [],
      CAdataPrevYearFetching: true,
      CAisError: false,
      frequency: 'MONTHLY',
      period: props.eventStatsFilter.year,
      languages: ['FR', 'NL', 'EN'],
      showCompareStats: false,
      chartType: 'REGISTRATION',
      legendType: 'TYPE',
      isBudgetManagementModalVisible: false,
      chartIsFetching: false,
      legendIsFetching: false,
      showSpinner: false,
      seasonsToShow: [],
      chartLinesToShowSeason: [],
      showCompareAppTypeStats: false,
      showCompareAppTypeStatsArray: [],
      lineNameForStats: '',
      compareAll: false,
      activePremium: {},
      accumulateEventStats: [],
      accumulateEventStatsCA: [],
      accumulateEventStatsFetching: false,
      accumulateEventStatsCAFetching: false,
      accumulateEventStatsPrevYear: [],
      accumulateEventStatsCAPrevYear: [],
      accumulateEventStatsPrevYearFetching: false,
      accumulateEventStatsCAPrevYearFetching: false,
      showAccumulateEventStats: false,
      formatAccumulateData: [],
      formatAccumulateCAData: [],
      isDownloadParticipantsStatsLoading: false,
    };

  }

  showChartLine = line => {
    const { chartLinesToShow } = this.state;

    this.setState({ chartLinesToShow: [...chartLinesToShow, line] })
  }

  showChartLineFormat = line => {
    const { chartLinesToShowFormat } = this.state;

    this.setState({ chartLinesToShowFormat: [...chartLinesToShowFormat, line] })
  }

  hideChartLine = line => {
    const { chartLinesToShow } = this.state;

    this.setState({
      chartLinesToShow: chartLinesToShow.filter(function (chartLine, i) {
        return chartLine != line
      })
    })

  }

  hideChartLineFormat = line => {
    const { chartLinesToShowFormat } = this.state;

    this.setState({
      chartLinesToShowFormat: chartLinesToShowFormat.filter(function (chartLine, i) {
        return chartLine != line
      })
    })

  }

  hideChartLineFormatSeason = line => {
    const { chartLinesToShowSeason } = this.state;

    this.setState({
      chartLinesToShowSeason: chartLinesToShowSeason.filter(function (chartLine, i) {
        return chartLine.lineName != line
      })
    })
  }

  showChartLineFormatSeason = line => {
    const { chartLinesToShowSeason, seasonsToShow } = this.state;
    const generatedColor = this.getRandomColor();

    this.setState({
      chartLinesToShowSeason: [...chartLinesToShowSeason, { legend: line, color: generatedColor, lineName: line }],
      // change the line color of the seasonsToShow by the generated color
      seasonsToShow: seasonsToShow.map(season => {
        if (season.legend === line) {
          return { ...season, color: generatedColor };
        }
        return season;
      })
    })
  }

  updateChartLinesToShow = (line) => {
    const { chartLinesToShow } = this.state;

    const found = chartLinesToShow.find(element => element == line);
    if (found) {
      this.hideChartLine(line);
      return;
    }

    this.showChartLine(line);
  }

  updateChartLinesToShowFormat = (line) => {
    const { chartLinesToShowFormat } = this.state;

    const found = chartLinesToShowFormat.find(element => element == line);

    if (found) {
      this.hideChartLineFormat(line);
      this.hideChartLineFormatSeason(line);
      return;
    }

    this.showChartLineFormat(line);
    this.showChartLineFormatSeason(line);
  }

  updateFrequency = (frequency) => {
    const { eventStatsFilter } = this.props;

    let period = [];

    if (frequency == "MONTHLY")
      period = eventStatsFilter.year;

    else if (frequency == "DAILY") {
      let currentMonth = moment().month() + 1;
      let currentMonthFormatted = eventStatsFilter.year[0] + '-' + (currentMonth >= 10 ? currentMonth : '0' + currentMonth);
      period = [currentMonthFormatted]
    }

    this.setState({ frequency, period, showCompareStats: false, showAccumulateEventStats: false });
  }

  updateChartType = (chartType) => {
    this.setState({ chartType });
  }

  updateLegendType = (legendType) => {
    this.setState({ legendType, showAccumulateEventStats: false, showCompareStats: false });
  }

  updatePeriod = (period) => {
    this.setState({ period, showAccumulateEventStats: false, showCompareStats: false });
  }

  fetchRegistrantLineChartAllData = () => {
    const { frequency, period, isError, languages } = this.state;
    this.setState({ fetching: true, CAfetching: true, isError: false, dataPrevYearFetching: true, CAdataPrevYearFetching: true });
    const { eventStatsFilter } = this.props;
    let previousYearDate = '';

    if (frequency === 'DAILY') {
      const date = period[0];
      const [yearDate, monthDate] = date.split("-");
      previousYearDate = `${eventStatsFilter.year - 1}-${monthDate}`;
    }

    this.props.fetchRegistrantLineChartData(frequency, period, languages).then((res) => {
      this.setState({ fetching: false, data: res.data.data });
      this.props.fetchRegistrantLineChartCAData(frequency, period, languages).then((res) => {
        this.setState({ CAfetching: false, CAdata: res.data.data });
        if (frequency === 'DAILY') {
          this.props.fetchRegistrantLineChartData(frequency, [previousYearDate], languages, 0, 1).then((res) => {
            this.setState({ fetching: false, dataPrevYear: res.data.data, dataPrevYearFetching: false });
            this.props.fetchRegistrantLineChartCAData(frequency, [previousYearDate], languages, 0, 1).then((res) => {
              this.setState({ CAfetching: false, CAdataPrevYear: res.data.data, CAdataPrevYearFetching: false });
            }).catch((err) => {
              if (!axios.isCancel(err)) {
                this.setState({ CAfetching: false, CAisError: true, CAdataPrevYear: [] });
                showErrorNotification(_('error'), _('errorOccured'));
              }
            });
          }).catch((err) => {
            if (!axios.isCancel(err)) {
              this.setState({ fetching: false, isError: true, dataPrevYear: [] });
              showErrorNotification(_('error'), _('errorOccured'));
            }
          });
        }
      }
      ).catch((err) => {
        if (!axios.isCancel(err)) {
          this.setState({ CAfetching: false, CAisError: true, CAdata: [] });
          showErrorNotification(_('error'), _('errorOccured'));
        }
      }
      );
    }
    ).catch((err) => {
      if (!axios.isCancel(err)) {
        this.setState({ fetching: false, isError: true, data: [] });
        showErrorNotification(_('error'), _('errorOccured'));
      }
    }
    );

    if (this.state.frequency === 'MONTHLY') {
      this.props.getActivePremium(period, frequency, '01', '12').then((res) => {
        this.setState({ activePremium: res.value.data.data });
      });
    }

    if (this.state.frequency === 'DAILY') {
      const date = period[0];
      const [yearDate, monthDate] = date.split("-");
      previousYearDate = `${eventStatsFilter.year - 1}-${monthDate}`;
      this.setState({ accumulateEventStatsFetching: true, accumulateEventStatsCAFetching: true, accumulateEventStatsPrevYearFetching: true, accumulateEventStatsCPrevYearFetching: true });
      this.props.getAccumulateEventStats(frequency, period, this.state.languages, 'NBR').then((res) => {
        this.setState({ accumulateEventStats: res.value.data.data, accumulateEventStatsFetching: false });
      });
      this.props.getAccumulateEventStats(frequency, period, this.state.languages, 'CA').then((res) => {
        this.setState({ accumulateEventStatsCA: res.value.data.data, accumulateEventStatsCAFetching: false });
      });

      this.props.getAccumulateEventStats(frequency, [previousYearDate], this.state.languages, 'NBR').then((res) => {
        this.setState({ accumulateEventStatsPrevYear: res.value.data.data, accumulateEventStatsPrevYearFetching: false });
      });
      this.props.getAccumulateEventStats(frequency, [previousYearDate], this.state.languages, 'CA').then((res) => {
        this.setState({ accumulateEventStatsCAPrevYear: res.value.data.data, accumulateEventStatsCAPrevYearFetching: false });
      });
    }
  }

  fetchRegistrantLineChartData = () => {
    const { frequency, period, isError, languages } = this.state;
    this.setState({ legendIsFetching: true });

    this.props.fetchRegistrantLineChartData(frequency, period, languages).then((res) => {
      this.setState({ data: res.data.data });
      this.setState({ legendIsFetching: false });
    }
    ).catch((err) => {
      if (!axios.isCancel(err)) {
        this.setState({ isError: true, data: [] });
        showErrorNotification(_('error'), _('errorOccured'));
      }
    }
    );
  }

  fetchRegistrantLineChartCAData = () => {
    const { frequency, period, CAisError, languages } = this.state;
    this.setState({ CAfetching: true, CAisError: false });
    const { eventStatsFilter } = this.props;

    this.props.fetchRegistrantLineChartCAData(frequency, period, languages).then((res) => {
      this.setState({ CAfetching: false, CAdata: res.data.data });
    }
    ).catch((err) => {
      if (!axios.isCancel(err)) {
        this.setState({ CAfetching: false, CAisError: true, CAdata: [] });
        showErrorNotification(_('error'), _('errorOccured'));
      }
    });
  }

  getCANbrInscriptionByFormat = () => {
    this.setState({ showSpinner: true, isFormatFetching: true, isFormatError: false });
    const { frequency, period, CAisError, languages, showAccumulateEventStats } = this.state;

    if (showAccumulateEventStats === false) {
      this.props.startCommandGetCANbrInscriptionByFormat(frequency, period, languages).then((res) => {
        // Clear previous timer
        clearInterval(this.commandTimer);

        const startCommandTimer = () => {
          // Pour éviter des requête concurrentes
          this.currRequestId = `COMMAND_REQUEST_${performance.now()}`;
          let prevRequestId = this.currRequestId;

          this.props.getCommandInfo(res.value.data.data.command.id)
            .then((resultat) => {

              if (prevRequestId !== this.currRequestId) {
                return;
              }

              if (resultat.data.data.status !== "FINISHED") {
                this.setState({ showSpinner: true, isFormatFetching: true });
                return;
              }

              let newSeasons = [];

              newSeasons = resultat.data.data.result.seasons.map(name => {
                return { legend: name, color: this.getRandomColor(), lineName: name };
              });

              let newSeasonsWithoutColorAndLinename = [];

              newSeasonsWithoutColorAndLinename = resultat.data.data.result.seasons.map(name => {
                return name;
              });

              // Arréter le timer
              this.setState({
                formatData: resultat.data.data.result.nbrInscrits,
                formatCAData: resultat.data.data.result.caffaire,
                seasonsToShow: newSeasons,
                chartLinesToShowSeason: newSeasons,
                chartLinesToShowFormat: newSeasonsWithoutColorAndLinename,
                showSpinner: false,
                isFormatFetching: false
              });

              clearInterval(this.commandTimer);

            })
            .catch(() => {
              clearInterval(this.commandTimer);
            });
        }

        this.commandTimer = setInterval(startCommandTimer, 3 * 1000);
      })
    }

    if (frequency === 'DAILY' && showAccumulateEventStats) {
      this.props.startCommandCumulateByFormat(frequency, period, languages, 'NBR').then((res) => {
        // Clear previous timer
        clearInterval(this.commandTimer);

        const startCommandTimer = () => {
          // Pour éviter des requête concurrentes
          this.currRequestId = `COMMAND_REQUEST_${performance.now()}`;
          let prevRequestId = this.currRequestId;

          this.props.getCommandInfo(res.value.data.data.command.id)
            .then((resultat) => {
              if (prevRequestId !== this.currRequestId) {
                return;
              }

              if (resultat.data.data.status !== "FINISHED") {
                this.setState({ showSpinner: true, isFormatFetching: true });
                return;
              }

              // Arréter le timer
              this.setState({
                formatAccumulateData: resultat.data.data.result,
                // showSpinner: false, 
                // isFormatFetching: false
              });

              clearInterval(this.commandTimer);

              this.props.startCommandCumulateByFormat(frequency, period, languages, 'CA').then((res) => {
                // Clear previous timer
                clearInterval(this.commandTimer);

                const startCommandTimer = () => {
                  // Pour éviter des requête concurrentes
                  this.currRequestId = `COMMAND_REQUEST_${performance.now()}`;
                  let prevRequestId = this.currRequestId;

                  this.props.getCommandInfo(res.value.data.data.command.id)
                    .then((resultat) => {
                      if (prevRequestId !== this.currRequestId) {
                        return;
                      }

                      if (resultat.data.data.status !== "FINISHED") {
                        this.setState({ showSpinner: true, isFormatFetching: true });
                        return;
                      }

                      // Arréter le timer
                      this.setState({
                        formatAccumulateCAData: resultat.data.data.result,
                        showSpinner: false,
                        isFormatFetching: false
                      });

                      clearInterval(this.commandTimer);

                    })
                    .catch(() => {
                      clearInterval(this.commandTimer);
                    });
                }

                this.commandTimer = setInterval(startCommandTimer, 3 * 1000);
              });

            })
            .catch(() => {
              clearInterval(this.commandTimer);
            });
        }

        this.commandTimer = setInterval(startCommandTimer, 3 * 1000);
      });
    }
  }

  updateLanguages = (language) => {
    const { languages } = this.state;
    if (!languages.includes(language)) {
      this.setState({
        languages: [...languages, language],
        showCompareStats: false
      })
    } else if (languages.length > 1) {
      this.setState({
        languages: languages.filter(function (lng, i) {
          return lng !== language
        }), showCompareStats: false
      })
    }
  }

  handleShowCompareStats = (showCompareStats) => {
    this.setState({ showCompareStats });
  }

  handleBudgetManagementModalVisibility = (value) => {
    this.setState({ isBudgetManagementModalVisible: value });
  };

  handleGetParticipantsStatsAction = () => {
    this.setState({ isDownloadParticipantsStatsLoading: true });
    this.props.getParticipantsStatsAction().then((res) => {
      const data = res.value.data.data;

      // Get all unique years from the data
      const allYears = new Set();
      data.forEach(participant => {
        if (participant.years) {
          Object.keys(participant.years).forEach(year => allYears.add(year));
        }
      });
      const sortedYears = Array.from(allYears).sort((a, b) => a - b); // Sort ascending

      // Define CSV headers - base info + year columns
      const baseHeaders = [
        'ID',
        'Prénom',
        'Nom',
        'Email',
        'Téléphone',
        'Numéro ITAA',
        'Langue',
        'L\'âge',
        'Province',
        'Total Heures Suivies',
        'Total Budget Dépensé'
      ];

      // Add year-specific headers
      const yearHeaders = [];
      sortedYears.forEach(year => {
        yearHeaders.push(
          `${year} Heures Suivies`,
          `${year} Événements uniques suivis`,
          `${year} Événements Cycle Suivis`,
          `${year} Cycles Suivis`,
          `${year} Événements Essentials Suivis`,
          `${year} Essentials Suivis`,
          `${year} Événements Saisons Suivis`,
          `${year} Saisons Suivies`,
          `${year} Événements Premium Suivis`,
          `${year} Premiums Suivis`,
          `${year} Budget Dépensé`
        );
      });

      const headers = [...baseHeaders, ...yearHeaders];

      // Create CSV content
      const csvRows = [];

      // Add header row
      csvRows.push(headers.join(';'));

      // Add data rows
      data.forEach(participant => {
        const baseRow = [
          participant.userId || '',
          participant.firstName || '',
          participant.lastName || '',
          participant.email || '',
          participant.phone || '',
          participant.itaaNumber || '',
          participant.language || '',
          // calculate age from birthday if needed
          participant.birthday ? moment().diff(moment(participant.birthday, 'YYYY-MM-DD'), 'years') : '',
          participant.province || '',
          participant.totalHoursFollowed || '0',
          participant.totalBudgetSpent || '0.00'
        ];

        // Add year-specific data
        const yearData = [];
        sortedYears.forEach(year => {
          const yearStats = participant.years && participant.years[year];
          if (yearStats) {
            yearData.push(
              yearStats.hoursFollowed || '0',
              yearStats.uniqueEventsFollowed || '0',
              yearStats.cycleEventsFollowed || '0',
              yearStats.cyclesFollowed || '0',
              yearStats.essentialEventsFollowed || '0',
              yearStats.essentialsFollowed || '0',
              yearStats.seasonEventsFollowed || '0',
              yearStats.seasonsFollowed || '0',
              yearStats.premiumEventsFollowed || '0',
              yearStats.premiumsFollowed || '0',
              yearStats.budgetSpent || '0.00'
            );
          } else {
            // Fill with zeros if year data doesn't exist
            yearData.push('0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0.00');
          }
        });

        const fullRow = [...baseRow, ...yearData];
        csvRows.push(fullRow.join(';'));
      });

      // Create CSV string with BOM for proper Excel encoding
      const csvContent = '\uFEFF' + csvRows.join('\n');

      // Create blob and download
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      // Generate filename with current date
      const date = new Date().toISOString().split('T')[0];
      const filename = `participants_stats_${date}.csv`;

      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.setState({ isDownloadParticipantsStatsLoading: false });
    }).catch((error) => {
      console.error('Error fetching participants stats:', error);
      this.setState({ isDownloadParticipantsStatsLoading: false });
    });
  }

  componentDidMount() {
    this.fetchRegistrantLineChartAllData();
    // this.fetchRegistrantLineChartCAData();
    // this.getCANbrInscriptionByFormat();
    if (this.props.auth.currentClient.businessType === 'SUPER_CHAIN') {
      const showCompareAppTypeStatsArray = [];
      showCompareAppTypeStatsArray['formations'] = false;
      showCompareAppTypeStatsArray['cycles'] = false;
      showCompareAppTypeStatsArray['cycles_essential'] = false;
      showCompareAppTypeStatsArray['saisons'] = false;
      showCompareAppTypeStatsArray['monthly_premium'] = false;
      showCompareAppTypeStatsArray['yearly_premium'] = false;
      showCompareAppTypeStatsArray['congrès'] = false;
      this.setState({ showCompareAppTypeStatsArray: showCompareAppTypeStatsArray })
    } else if (this.props.auth.currentClient.businessType === 'MASTER_CHAIN') {
      const showCompareAppTypeStatsArray = [];
      showCompareAppTypeStatsArray['formations'] = false;
      showCompareAppTypeStatsArray['cycles'] = false;
      this.setState({ showCompareAppTypeStatsArray: showCompareAppTypeStatsArray })
    } else {
      const showCompareAppTypeStatsArray = [];
      showCompareAppTypeStatsArray['formations'] = false;
      this.setState({ showCompareAppTypeStatsArray: showCompareAppTypeStatsArray })
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { frequency, period, languages, chartType, legendType } = this.state;
    const { eventStatsFilter } = this.props;

    if (prevState.frequency != frequency || prevState.period != period || prevState.languages != languages || prevState.legendType != legendType || prevState.showAccumulateEventStats != this.state.showAccumulateEventStats) {
      if (legendType === 'TYPE') {
        this.fetchRegistrantLineChartAllData();
      } else {
        this.getCANbrInscriptionByFormat();
      }
    }
    if (prevProps.eventStatsFilter.year != eventStatsFilter.year) {
      if (eventStatsFilter.year.length == 0)
        this.setState({ frequency: 'YEARLY', period: [], showCompareStats: false });
      else if (eventStatsFilter.year.length == 1)
        this.setState({ frequency: 'MONTHLY', period: eventStatsFilter.year, showCompareStats: false });
    }

    if (prevProps.eventStatsFilter.year !== this.props.eventStatsFilter.year) {
      this.getSeasons();
    }

    // if(prevProps.seasons && (prevProps.seasons.items !== this.props.seasons.items)) {
    //   let seasons = this.props.seasons.items;
    //   let newSeasons = [];

    //   newSeasons = seasons.map(part => {
    //     let label = '';
    //     if (part.name_fr) {
    //       label = part.name_fr;
    //     } else if (part.name_en) {
    //       label = part.name_en;
    //     } else if (part.name_nl) {
    //       label = part.name_nl;
    //     }

    //     return label;
    //   });

    //   newSeasons.push("Aucune Format");

    //   this.setState({ chartLinesToShowFormat: newSeasons });
    // }

    if (prevProps.eventStatsFilter.year !== this.props.eventStatsFilter.year) {
      this.getSeasons();
    }

    // if(prevProps.seasons && (prevProps.seasons.items !== this.props.seasons.items)) {
    //   let seasons = this.props.seasons.items;
    //   let newSeasons = [];

    //   newSeasons = seasons.map(part => {
    //     let label = '';
    //     if (part.name_fr) {
    //       label = part.name_fr;
    //     } else if (part.name_en) {
    //       label = part.name_en;
    //     } else if (part.name_nl) {
    //       label = part.name_nl;
    //     }

    //     return { legend: label, color: this.getRandomColor(), lineName: label };
    //   });

    //   newSeasons.push({ legend: 'Aucune Format', color: this.getRandomColor(), lineName: "Aucune Format" });

    //   this.setState({ seasonsToShow: newSeasons, chartLinesToShowSeason: newSeasons });
    // }

  }

  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  getSeasons = () => {
    let params = {};

    if (this.props.auth.currentClient) {
      params.issuerId = this.props.auth.currentClient.id;
    }

    this.props.getSeasonsValues(params);
  }

  showCompareStatsForAppType = (lineName) => {
    if (lineName === this.state.lineNameForStats) {

      const showCompareAppTypeStatsArray = Object.keys(this.state.showCompareAppTypeStatsArray).reduce(
        (acc, key) => {
          acc[key] = false;
          return acc;
        },
        {}
      );
      this.setState({ showCompareAppTypeStats: false, lineNameForStats: '', showCompareAppTypeStatsArray: showCompareAppTypeStatsArray });
      return;
    };
    const showCompareAppTypeStatsArray = Object.keys(this.state.showCompareAppTypeStatsArray).reduce(
      (acc, key) => {
        acc[key] = key === lineName;
        return acc;
      },
      {}
    );
    this.setState({ showCompareAppTypeStats: true, lineNameForStats: lineName, showCompareAppTypeStatsArray: showCompareAppTypeStatsArray, compareAll: false });
  }

  showCompareStatsForAllAppType = (compareAll) => {
    const showCompareAppTypeStatsArray = Object.keys(this.state.showCompareAppTypeStatsArray).reduce(
      (acc, key) => {
        acc[key] = false;
        return acc;
      },
      {}
    );
    this.setState({ showCompareAppTypeStats: !compareAll, lineNameForStats: '', showCompareAppTypeStatsArray: showCompareAppTypeStatsArray, compareAll: !compareAll });
  };

  handleCancelDailyCompareAppType = () => {
    const showCompareAppTypeStatsArray = Object.keys(this.state.showCompareAppTypeStatsArray).reduce(
      (acc, key) => {
        acc[key] = false;
        return acc;
      },
      {}
    );
    this.setState({ showCompareAppTypeStats: false, lineNameForStats: '', showCompareAppTypeStatsArray: showCompareAppTypeStatsArray });
  };

  handleShowAccumulateEventStats = (event) => {
    this.setState({ showAccumulateEventStats: event.target.checked });
  }

  render() {
    const {
      chartLinesToShow,
      fetching,
      CAfetching,
      frequency,
      data,
      CAdata,
      isError,
      CAisError,
      period,
      languages,
      showCompareStats,
      chartType,
      legendType,
      isBudgetManagementModalVisible,
      chartLinesToShowFormat,
      formatData,
      formatCAData,
      isFormatFetching,
      isFormatError,
      seasonsToShow,
      chartLinesToShowSeason,
      showSpinner,
      showCompareAppTypeStats,
      lineNameForStats,
      dataPrevYear,
      CAdataPrevYear,
      dataPrevYearFetching,
      CAdataPrevYearFetching,
      showCompareAppTypeStatsArray,
      activePremium,
      accumulateEventStats,
      accumulateEventStatsCA,
      accumulateEventStatsFetching,
      accumulateEventStatsCAFetching,
      accumulateEventStatsPrevYear,
      accumulateEventStatsCAPrevYear,
      accumulateEventStatsPrevYearFetching,
      accumulateEventStatsCAPrevYearFetching,
      showAccumulateEventStats,
      formatAccumulateData,
      formatAccumulateCAData,
    } = this.state;
    const { eventStatsFilter, language } = this.props;
    const chartData = data;
    const chartDataCA = CAdata;

    const isFetching = fetching || CAfetching;
    const error = CAisError || isError;

    const chartDataByLinename = lineNameForStats ? data.map(item => ({
      name: item.name,
      [lineNameForStats]: item[lineNameForStats]
    })) : data;

    const chartDataByLinenameAccumulate = lineNameForStats ? accumulateEventStats.map(item => ({
      name: item.name,
      [lineNameForStats]: item[lineNameForStats]
    })) : accumulateEventStats;

    const chartDataCAByLinename = lineNameForStats ? CAdata.map(item => ({
      name: item.name,
      [lineNameForStats]: item[lineNameForStats]
    })) : CAdata;

    const chartDataCAByLinenamAccumulate = lineNameForStats ? accumulateEventStatsCA.map(item => ({
      name: item.name,
      [lineNameForStats]: item[lineNameForStats]
    })) : accumulateEventStatsCA;

    const chartDataByLinenamePrevYear = lineNameForStats ? dataPrevYear.map(item => ({
      name: item.name,
      [lineNameForStats]: item[lineNameForStats]
    })) : dataPrevYear;

    const chartDataByLinenamePrevYearAccumulate = lineNameForStats ? accumulateEventStatsPrevYear.map(item => ({
      name: item.name,
      [lineNameForStats]: item[lineNameForStats]
    })) : accumulateEventStatsPrevYear;

    const chartDataCAByLinenamePrevYear = lineNameForStats ? CAdataPrevYear.map(item => ({
      name: item.name,
      [lineNameForStats]: item[lineNameForStats]
    })) : CAdataPrevYear;

    const chartDataCAByLinenamePrevYearAccumulate = lineNameForStats ? accumulateEventStatsCAPrevYear.map(item => ({
      name: item.name,
      [lineNameForStats]: item[lineNameForStats]
    })) : accumulateEventStatsCAPrevYear;

    return (
      <div className={"event-registrant-line-chart"} style={{ position: 'relative', zIndex: 99 }}>

        <EventLineChartFilters
          updateFrequency={this.updateFrequency}
          frequency={frequency}
          updatePeriod={this.updatePeriod}
          period={period}
          language={language}
          languages={languages}
          type={chartType}
          legendType={legendType}
          updateLanguages={this.updateLanguages}
          updateChartType={this.updateChartType}
          updateLegendType={this.updateLegendType}
          eventStatsFilter={eventStatsFilter}
          showAccumulateEventStats={this.state.showAccumulateEventStats}
          handleShowAccumulateEventStats={this.handleShowAccumulateEventStats}
          fetching={isFetching || accumulateEventStatsFetching || accumulateEventStatsCAFetching || accumulateEventStatsPrevYearFetching || accumulateEventStatsCAPrevYearFetching}
        />

        <div className="event-registrant-line-chart-body">
          <div className="event-registrant-line-chart-body-aside">
            {
              legendType === 'TYPE' ?
                <EventLineChartLegend
                  updateChartLinesToShow={this.updateChartLinesToShow}
                  chartLinesToShow={chartLinesToShow}
                  chartData={chartData}
                  chartDataCA={chartDataCA}
                  fetching={isFetching}
                  isError={error}
                  type={chartType}
                  frequency={frequency}
                  showCompareAppTypeStats={showCompareAppTypeStats}
                  showCompareStatsForAppType={this.showCompareStatsForAppType}
                  dataPrevYearFetching={dataPrevYearFetching}
                  CAdataPrevYearFetching={CAdataPrevYearFetching}
                  showCompareAppTypeStatsArray={showCompareAppTypeStatsArray}
                  handleCancelDailyCompareAppType={this.handleCancelDailyCompareAppType}
                  showCompareStats={showCompareStats}
                  showCompareStatsForAllAppType={this.showCompareStatsForAllAppType}
                  compareAll={this.state.compareAll}
                  activePremium={activePremium}
                /> : (showSpinner ? (<CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"} />) :
                  <EventLineChartLegendFormat
                    updateChartLinesToShow={this.updateChartLinesToShowFormat}
                    chartLinesToShowFormat={chartLinesToShowFormat}
                    formatData={formatData}
                    formatCAData={formatCAData}
                    fetching={isFormatFetching}
                    isError={isFormatError}
                    type={legendType}
                    showSpinner={showSpinner}
                    seasonsToShow={seasonsToShow}
                    frequency={frequency}
                    period={period}
                  />
                )
            }
          </div>
          <div className="event-registrant-line-chart-body-main" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: '20px', gap: '20px' }}>
            {
              showCompareAppTypeStats === false ?
                legendType === 'TYPE' ?
                  error ?
                    <EventLineChartErrorHandler
                      fetchRegistrantLineChartData={this.fetchRegistrantLineChartData}
                      fetchRegistrantLineChartCAData={this.fetchRegistrantLineChartCAData}
                      type={chartType}
                    /> :
                    <EventLineChart
                      data={chartType === 'CA' ? (showAccumulateEventStats ? accumulateEventStatsCA : chartDataCA) : (showAccumulateEventStats ? accumulateEventStats : chartData)}
                      chartLinesToShow={chartLinesToShow}
                      fetching={isFetching || accumulateEventStatsFetching || accumulateEventStatsCAFetching}
                      language={language}
                      type={chartType}
                      updateChartType={this.updateChartType}
                      frequency={frequency}
                      period={period}
                    />
                  : error ?
                    <EventLineChartErrorHandler
                      fetchRegistrantLineChartData={this.fetchRegistrantLineChartData}
                      fetchRegistrantLineChartCAData={this.fetchRegistrantLineChartCAData}
                      type={chartType}
                    /> :
                    <EventLineChartFormat
                      data={chartType === 'CA' ? formatCAData : formatData}
                      chartLinesToShowSeason={chartLinesToShowSeason}
                      fetching={isFormatFetching}
                      language={language}
                      type={chartType}
                      updateChartType={this.updateChartType}
                      seasonsToShow={seasonsToShow}
                      frequency={frequency}
                      period={period}
                      showAccumulateEventStats={showAccumulateEventStats}
                      formatAccumulateData={formatAccumulateData}
                      formatAccumulateCAData={formatAccumulateCAData}
                    />
                : null
            }
            {
              legendType === 'TYPE' && showCompareAppTypeStats === true && frequency === 'DAILY' ?
                <CompareStatsChart
                  data1={chartType === 'CA' ? (showAccumulateEventStats ? chartDataCAByLinenamAccumulate : chartDataCAByLinename) : (showAccumulateEventStats ? chartDataByLinenameAccumulate : chartDataByLinename)}
                  data2={chartType === 'CA' ? (showAccumulateEventStats ? chartDataCAByLinenamePrevYearAccumulate : chartDataCAByLinenamePrevYear) : (showAccumulateEventStats ? chartDataByLinenamePrevYearAccumulate : chartDataByLinenamePrevYear)}
                  chartLinesToShow={chartLinesToShow}
                  fetching={isFetching || dataPrevYearFetching || CAdataPrevYearFetching}
                  language={language}
                  year1={eventStatsFilter.year[0]}
                  year2={eventStatsFilter.year[0] - 1}
                  type={chartType}
                  startMonth={'01'}
                  endMonth={'12'}
                  updateType={this.updateChartType}
                  frequency={frequency}
                />
                : null
            }
          </div>
        </div>
        {
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "2%" }} className="mt-3">
            <div style={{ display: "flex", alignItems: "center", width: "40%", justifyContent: "space-between" }}>
              <div className={"event-manage-turnover"} style={{ margin: 0 }} onClick={() => this.handleBudgetManagementModalVisibility(true)}>
                <img src="/img/icons/event-stats/settings.svg" className={'mr-1'} />
                <span>{_("MANAGE_MY_TURNOVER")}</span>
              </div>
              {frequency === "YEARLY" && eventStatsFilter.year.length === 1 &&
                <span style={{ cursor: "pointer" }} onClick={this.handleGetParticipantsStatsAction}>{this.state.isDownloadParticipantsStatsLoading && <SyncOutlined spin />} Télécharger les détails des inscriptions</span>
              }
            </div>
            <div style={{ width: "60%" }} />
          </div>
        }
        {showCompareStats && (frequency === "MONTHLY" || frequency === "DAILY") &&
          <CompareStats
            chartData1={chartData}
            chartDataCA1={chartDataCA}
            formatData1={formatData}
            formatCAData1={formatCAData}
            languages={languages}
            type={chartType}
            legendType={legendType}
            isFetching={isFetching}
            isError={isError}
            updateChartType={this.updateChartType}
            updateLegendType={this.updateLegendType}
            updateChartLinesToShowFormat={this.updateChartLinesToShowFormat}
            chartLinesToShowFormat={chartLinesToShowFormat}
            chartLinesToShowSeason={chartLinesToShowSeason}
            isFormatFetching={isFormatFetching}
            isFormatError={isFormatError}
            seasonsToShow={seasonsToShow}
            frequency={frequency}
            language={language}
            period={period}
            activePremium={activePremium}
            showCompareStats={showCompareStats}
            showAccumulateEventStats={showAccumulateEventStats}
            accumulateEventStats={accumulateEventStats}
            accumulateEventStatsCA={accumulateEventStatsCA}
            accumulateEventStatsFetching={accumulateEventStatsFetching}
            accumulateEventStatsCAFetching={accumulateEventStatsCAFetching}
            formatAccumulateData={formatAccumulateData}
            formatAccumulateCAData={formatAccumulateCAData}
          />
        }
        {
          (frequency === "MONTHLY" || frequency === "DAILY") && isFetching === false && chartData.length > 0 && showCompareAppTypeStats === false &&
          <div className={"flex flex-col items-center mt-3"}>
            <span className={"event-cycle-trainings"} onClick={() => this.handleShowCompareStats(!showCompareStats)}>{showCompareStats ? _("REDUCE") : _("COMPARE_WITH_ANOTHER_YEAR")}</span>
            <div className={"event-cycle-chevron"} onClick={() => this.handleShowCompareStats(!showCompareStats)}>
              <img src="/img/icons/chevron-down.svg" className={showCompareStats && "cycle-stats-chevron-rotate"} />
            </div>
          </div>
        }
        {isBudgetManagementModalVisible === true && <BudgetManagementModal handleModalVisibility={this.handleBudgetManagementModalVisibility} />}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
  seasons: state.seasons,
  language: state.params.lng,
});

const mapDispatchToProps = {
  fetchRegistrantLineChartData,
  fetchRegistrantLineChartCAData,
  getSeasonsValues,
  startCommandGetCANbrInscriptionByFormat,
  getCommandInfo,
  getActivePremium,
  getAccumulateEventStats,
  startCommandCumulateByFormat,
  getParticipantsStatsAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(EventRegistrantLineChart);



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/EventRegistrantLineChart.js